<template>
  <div class="kq-theme-tab">
    <div class="kq-theme-tab-main">
      <tab-dropdown
        :visible.sync="tabDropdownVisible"
        :list="dropdownList"
        :x="tabDropdownX"
        :y="tabDropdownY"
        @close="closeTabCallback"
      />
      <el-tabs
        class="kq-theme-tab-content ax-multiple-page-sort"
        :value="$route.path"
        type="card"
        @tab-click="selectTab"
        @tab-remove="removeTab"
        @contextmenu.native="contextmenu"
      >
        <el-tab-pane
          v-for="tab of tabs"
          :key="tab.path"
          :label="tab.title"
          :name="tab.path"
          :closable="!tab.fixedTab"
        />
      </el-tabs>
    </div>
    <div class="kq-theme-tab-btn">
      <el-dropdown size="default" split-button @click="closeAll" @command="closeTabDropdown">
        <kq-icon name="times-circle" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item of dropdownList" :key="item.command" :command="item.command">
            <kq-icon :name="item.icon" />
            <span class="kq-theme-tab-btn-title">{{ item.title }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Sortable from 'sortablejs'
import TabDropdown from './TabDropdown'

export default {
  name: 'PageTabs',
  components: { TabDropdown },
  data() {
    return {
      dropdownList: [
        {
          icon: 'arrow-left',
          title: '关闭左侧',
          command: 'left'
        },
        {
          icon: 'arrow-right',
          title: '关闭右侧',
          command: 'right'
        },
        {
          icon: 'times',
          title: '关闭其它',
          command: 'other'
        },
        {
          icon: 'times-circle',
          title: '全部关闭',
          command: 'all'
        }
      ],

      path: '/',
      tabDropdownVisible: false,
      tabDropdownX: 0,
      tabDropdownY: 0
    }
  },
  computed: {
    ...mapState('tab', ['tabs'])
  },
  mounted() {
    Sortable.create(document.querySelectorAll('.kq-theme-tab-content .el-tabs__nav')[0], {
      onEnd: val =>
        this.sort({
          oldIndex: val.oldIndex,
          newIndex: val.newIndex
        })
    })
  },
  methods: {
    ...mapActions('tab', ['close', 'closeLeft', 'closeRight', 'closeOther', 'closeAll', 'sort']),

    /**
     * 右键点击
     */
    contextmenu(event) {
      let element = this.getElement(event)
      if (element) {
        event.preventDefault()
        event.stopPropagation()
        this.path = element.getAttribute('aria-controls').slice(5)
        this.tabDropdownVisible = true
        this.tabDropdownX = event.clientX
        this.tabDropdownY = event.clientY
      }
    },

    /**
     * 获取右键点击事件的组件
     */
    getElement(event) {
      if (event.target.className.indexOf('el-tabs__item') > -1) {
        return event.target
      } else if (event.target.parentNode.className.indexOf('el-tabs__item') > -1) {
        return event.target.parentNode
      } else {
        return null
      }
    },

    /**
     * 悬浮框关闭tab回调
     */
    closeTabCallback(command) {
      this.closeTab(command, this.path)
      this.tabDropdownVisible = false
    },

    /**
     * dropdown关闭tab回调
     */
    closeTabDropdown(command) {
      this.closeTab(command, '')
    },

    /**
     * 根据类型关闭tab
     */
    closeTab(command, path) {
      const params = {
        path: path || this.$route.path,
        current: this.$route.path
      }
      switch (command) {
        case 'left':
          this.closeLeft(params)
          break
        case 'right':
          this.closeRight(params)
          break
        case 'other':
          this.closeOther(params)
          break
        case 'all':
          this.closeAll(params)
          break
      }
    },

    /**
     * 选中tab
     */
    selectTab(val) {
      const { name, params = {}, query = {} } = this.tabs.find(tab => tab.path === val.name)
      this.$router.push({
        name,
        params,
        query
      })
    },

    /**
     * 关闭tab
     */
    removeTab(path) {
      this.close({
        path,
        current: this.$route.path
      })
    }
  }
}
</script>
